module.exports = __webpack_public_path__ + "img/store.c285280c.png";